import React from "react";
import { motion } from "framer-motion";
import "./PartnersSection.css";

const PartnersSection = () => {
  const partners = [
    {
      name: "Google",
      label: "Trusted Google Partner",
      logo: (
        <img
          src="/images/google-icon.png"
          alt="Google Partner"
          className="partner-img"
          width="512"
          height="512"
          loading="lazy"
        />
      ),
      alt: "Google Partner",
    },
    {
      name: "Meta",
      label: "Trusted Meta Partner",
      logo: (
        <img
          src="/images/meta-icon.png"
          alt="Meta Business Partner"
          className="partner-img"
          width="512"
          height="512"
          loading="lazy"
        />
      ),
      alt: "Meta Business Partner",
    },
    {
      name: "Toyota",
      label: "",
      logo: (
        <img
          src="/images/toyota-icon.png"
          alt="Toyota"
          className="partner-img"
          width="512"
          height="512"
          loading="lazy"
        />
      ),
      alt: "Toyota",
    },
    {
      name: "Apple",
      label: "",
      logo: (
        <img
          src="/images/apple-icon.png"
          alt="Apple"
          className="partner-img"
          width="512"
          height="512"
          loading="lazy"
        />
      ),
      alt: "Apple",
    },
    {
      name: "Xiaomi",
      label: "",
      logo: (
        <img
          src="/images/xiaomi-icon.png"
          alt="Xiaomi"
          className="partner-img"
          width="512"
          height="512"
          loading="lazy"
        />
      ),
      alt: "Xiaomi",
    },
    {
      name: "Microsoft",
      label: "",
      logo: (
        <img
          src="/images/microsoft-icon.png"
          alt="Microsoft"
          className="partner-img"
          width="512"
          height="512"
          loading="lazy"
        />
      ),
      alt: "Microsoft",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <section className="partners-section">
      <div className="partners-container">
        <div className="partners-content">
          <motion.h2
            className="partners-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Trusted to accelerate
            <br />
            forward-thinking brands
          </motion.h2>

          <motion.div
            className="partners-logo-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
          >
            {partners.map((partner, index) => (
              <motion.div
                key={index}
                className="partner-logo-container"
                variants={itemVariants}
              >
                <div className="partner-logo">{partner.logo}</div>
                {partner.label && (
                  <div className="partner-label">{partner.label}</div>
                )}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
